import { inject, Injectable, OnInit } from '@angular/core';
import { waitSeconds } from '@reflact/tsutil';
import { BehaviorSubject } from 'rxjs';
import { Api } from '../api';
import { ChatService } from './chat/chat.service';
import { SocketService } from '../socket.service';

@Injectable({
  providedIn: 'root'
})
export class ClockService {
  public api = inject(Api);
  public chatService = inject(ChatService);
  public socketService = inject(SocketService);
  public clockStr = "00:00:00";
  public timeIsOver: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public isExamMode(): boolean {
    return this.api.fallaufgabe?.type === 'exam';
  }

  constructor() {
    if (this.isExamMode()) {
      this.clockUpdater();
      this.socketService.getIo().then((socket) => {
        socket.on("showRemainingTime", () => {
          this.postRemainingTime();
        });
      });
    }
  }

  public async clockUpdater() {
    if (!this.isExamMode()) {
      this.clockStr = "";
      return;
    }
    if (this.api.fallaufgabeStatus == null) {
      this.clockStr = "00:00:00";
    } else {
      const secondsToTime = (inputSeconds: number) => {
        if (inputSeconds <= 0) {
          return "00:00:00";
        }
        const hours = Math.floor(inputSeconds / 3600);
        const minutes = Math.floor((inputSeconds % 3600) / 60);
        const seconds = inputSeconds % 60;
        const hh = String(hours).padStart(2, '0');
        const mm = String(minutes).padStart(2, '0');
        const ss = String(seconds).padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
      };
      const endTime = new Date(this.api.fallaufgabeStatus.endDate).getTime();

      const difference = Math.round(endTime / 1000) - Math.round(new Date().getTime() / 1000);
      if (difference <= 0 && !this.timeIsOver.getValue()) {
        this.timeIsOver.next(true);
      }
      const newTextContent = "Verbleibende Zeit: " + secondsToTime(difference);

      this.clockStr = newTextContent;

      if (newTextContent == "Verbleibende Zeit: " + secondsToTime(3600 * 2)) { // bei 2h
        this.chatService.addMessage('Die verbleibende Zeit beträgt nun noch zwei Stunden', 'assistant');
      }
      if (newTextContent == "Verbleibende Zeit: " + secondsToTime(3600)) { // bei 1h
        this.chatService.addMessage('Die verbleibende Zeit beträgt nun noch eine Stunde', 'assistant');
      }
      if (newTextContent == "Verbleibende Zeit: " + secondsToTime(30 * 60)) { // bei 30m
        this.chatService.addMessage('Die verbleibende Zeit beträgt nun noch 30 Minuten', 'assistant');
      }
      if (newTextContent == "Verbleibende Zeit: " + secondsToTime(5 * 60)) { // bei 5m
        this.chatService.addMessage('Die verbleibende Zeit beträgt nun noch 5 Minuten', 'assistant');
      }
    }
    await waitSeconds(1)
    this.clockUpdater()
  }

  public async postRemainingTime() {
    if (!this.isExamMode()) {
      return;
    }
    this.chatService.addMessage(this.clockStr, 'assistant');
  }
}